import React from 'react'
import { toast } from 'react-toastify'
import { LoadingButton } from '@mui/lab'
import { Alert, Box, CircularProgress, Dialog, Stack } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import SubscriptionsAPI from 'api/faber/SubscriptionsAPI'
import TextColorFontHeader from 'common/Typography/TextColorFontHeader'

function CancelSubV2Dialog({
  handleCancelDialogClose,
  cancelDialogOpen,
  faberToken,
  customerId,
  onSuccessfulFormSubmission
}: CancelProps) {
  const { mutate: confirmCancelSubscription, isLoading: isCancelSubLoading } =
    useMutation(SubscriptionsAPI.cancelSubscriptionImmediately, {
      onSuccess: () => {
        toast.success('Subscription cancelled')
      },
      onError: () => {
        toast.error('Error cancelling subscription')
      },
      onSettled: () => {
        handleCancelDialogClose()
      }
    })

  const handleConfirmCancelSubscription = () => {
    confirmCancelSubscription({
      UserID: customerId,
      faberToken: faberToken
    })
    onSuccessfulFormSubmission()
  }
  return (
    <Dialog open={cancelDialogOpen} onClose={() => handleCancelDialogClose()}>
      <Stack spacing={2}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mt: 2
          }}
        >
          <TextColorFontHeader>
            Are you sure you want to cancel this user&apos;s subscription?
          </TextColorFontHeader>
        </Box>
        <Alert severity='warning'>
          Take note that this sets the user&apos;s subscription to
          <b> &apos;cancelled&apos;</b> immediately!
        </Alert>
        <Stack direction='row' justifyContent={'center'} sx={{ p: 2 }}>
          <LoadingButton onClick={() => handleCancelDialogClose()}>
            Cancel
          </LoadingButton>
          <LoadingButton
            loading={isCancelSubLoading}
            loadingIndicator={
              <CircularProgress size={20} sx={{ color: 'white' }} />
            }
            sx={{
              backgroundColor: '#bd1144',
              borderColor: '#bd1144',
              color: 'white',
              marginLeft: '30px',
              ':hover': {
                backgroundColor: '#a4113d'
              }
            }}
            onClick={handleConfirmCancelSubscription}
          >
            Confirm
          </LoadingButton>
        </Stack>
      </Stack>
    </Dialog>
  )
}

export default CancelSubV2Dialog
interface CancelProps {
  handleCancelDialogClose: () => void
  cancelDialogOpen: boolean
  customerId: string
  faberToken: string
  onSuccessfulFormSubmission: () => void
}
